import { render, staticRenderFns } from "./ElectionCampaignChronic.vue?vue&type=template&id=4a92ec2d&scoped=true"
import script from "./ElectionCampaignChronic.vue?vue&type=script&lang=js"
export * from "./ElectionCampaignChronic.vue?vue&type=script&lang=js"
import style0 from "./ElectionCampaignChronic.vue?vue&type=style&index=0&id=4a92ec2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a92ec2d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VContainer,VSlideYTransition})
